import { join as joinPath } from 'path';

import React, { createContext, useContext, useCallback } from 'react';
import styled from 'styled-components';

import { stringify as stringifyQuery } from 'querystring';

import Select from 'antd/lib/select';

import Types from '../modules/types';

export const Context = createContext();

export function Provider({ systemCountry, children }) {
  return (
    <Context.Provider value={systemCountry}>
      {children}
    </Context.Provider>
  );
}

export function useSystemCountry() {
  return useContext(Context);
}

export function Currency({ prefix, suffix }) {
  const systemCountry = useSystemCountry();
  const currency = systemCountry ? systemCountry.currency : '-';
  return `${prefix || ''}${currency}${suffix || ''}`;
}

export function renderCurrency({ prefix, suffix } = {}) {
  return (
    <Currency
      prefix={prefix}
      suffix={suffix}
    />
  );
}

const SwitcherWrapper = styled.div`
  display: flex;
  width: calc(100% + 46px);
  margin: 0 -23px;
  > .ant-select {
    width: 100%;
  }
  .ant-select-selection {
    background: hsla(0, 0%, 100%, 0.5) !important;
    border: none;
    padding: 6px 7px 2px 10px;
    font-weight: 600;
    height: 40px;
  }
  #root > .ant-layout > .ant-layout-sider .ant-menu &
   > .ant-select > .ant-select-selection > .ant-select-arrow > i > svg {
    transform: scale(0.64, 0.56) !important;
    opacity: 1 !important;

    path {
      fill: #222;
    }
  }
`;

export function Switcher(_props) {
  const systemCountry = useSystemCountry();
  const value = systemCountry ? systemCountry.id : Types.SYSTEM_COUNTRY[0];
  const onClick = useCallback(
    ({ key: newSystemCountry }) => {
      const newPath = `${joinPath(window.ADMIN_BASE, '/users/me')}?${
        stringifyQuery({ sc: newSystemCountry })
      }`;
      window.location = newPath;
    },
    [],
  );
  return (
    <SwitcherWrapper className="system-country-picker">
      <Select value={value}>
        {
          Types.SYSTEM_COUNTRY_LIST.map((item) => (
            <Select.Option
              key={item.id}
              value={item.id}
              onClick={onClick}
              className="system-country-picker-options"
            >
              {item.label}
            </Select.Option>
          ))
        }
      </Select>
    </SwitcherWrapper>
  );
}
